import Vue from 'vue';
import Router from 'vue-router';
import { decodeQuery, encodeQuery } from 'beans-admin-plugin';

Vue.use(Router)

export const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: require('@/views/home').default,
    meta: {
      navbar: 'el-icon-s-home',
      title: '店铺概览'
    },
  },
  require('@/views/data-analysis/route').default,
  require('@/views/products/route').default,
  require('@/views/orders/route').default,
  require('@/views/users/route').default,
  require('@/views/custom-pages/route').default,
  require('@/views/settings/route').default,
];

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_ROUTER_BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  parseQuery (query) {
    return decodeQuery(query);
  },
  stringifyQuery (query) {
    return encodeQuery(query);
  }
});

export default router
